/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { ExperienceOption } from '@/redux/slices/user/types';

export type AppOnboardingModalStep = 'tailorExperience' | 'educatorDetails' | 'favoriteAnimals';

export interface AppOnboardingModalState extends Record<AppOnboardingModalStep, boolean> {
  selectedExperienceOption: ExperienceOption | null;
  partnerName: string;
}

const initialState: AppOnboardingModalState = {
  tailorExperience: false,
  educatorDetails: false,
  favoriteAnimals: false,
  selectedExperienceOption: null,
  partnerName: 'zoolife',
};

const appOnboardingModalSlice = createSlice({
  name: 'appOnboardingModal',
  initialState,
  reducers: {
    flagAppOnboardingModalStep: (state, { payload }: PayloadAction<AppOnboardingModalStep>) => {
      state[payload] = true;
    },
    unflagAppOnboardingModalStep: (state, { payload }: PayloadAction<AppOnboardingModalStep>) => {
      state[payload] = false;
    },
    setSelectedExperienceOption: (state, { payload }: PayloadAction<ExperienceOption>) => {
      state.selectedExperienceOption = payload;
    },
    setPartnerName: (state, { payload }: PayloadAction<string>) => {
      state.partnerName = payload;
    },
  },
});

export default appOnboardingModalSlice;
